import { type QuestionTypeOption } from './dynamicDTOs';

export const questionTypes2: QuestionTypeOption[] = [
    {
        id: 11,
        key: 'add',
        name: 'Add',
        params: [
            {
                name: 'displayMode',
                displayName: 'Display Mode',
                type: 'select',
                options: [
                    { id: 1, name: 'Horizontal' },
                    { id: 2, name: 'Vertical' },
                ],
                default: 1,
            },
            {
                name: 'firstMin',
                displayName: 'First Min',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: -100,
            },
            {
                name: 'firstMax',
                displayName: 'First Max',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: 100,
            },
            {
                name: 'firstIncrement',
                displayName: 'First Increment',
                type: 'number',
                min: 0.00000000001,
                max: 2000000000,
                default: 1,
                increment: 0.00000000001,
                helpText: 'For example, if set to 10, numbers will be rounded to 10',
            },
            {
                name: 'secondMin',
                displayName: 'Second Min',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: -100,
            },
            {
                name: 'secondMax',
                displayName: 'Second Max',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: 100,
            },
            {
                name: 'secondIncrement',
                displayName: 'Second Increment',
                type: 'number',
                min: 0.00000000001,
                max: 2000000000,
                default: 1,
                increment: 0.00000000001,
                helpText: 'For example, if set to 10, numbers will be rounded to 10',
            },
            {
                name: 'sumMax',
                displayName: 'Sum Max',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: 100,
            },
        ],
        subTypes: [
            {
                id: 1,
                name: 'Sum Unknown',
            },
            {
                id: 2,
                name: 'First Unknown',
            },
            {
                id: 3,
                name: 'Second Unknown',
            },
        ],
    },
    {
        id: 12,
        key: 'addMultiple',
        name: 'Add Multiple',
        params: [
            {
                name: 'displayMode',
                displayName: 'Display Mode',
                type: 'select',
                options: [
                    { id: 1, name: 'Horizontal' },
                    { id: 2, name: 'Vertical' },
                ],
                default: 1,
            },
            {
                name: 'addendMin',
                displayName: 'Addend Min',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: 0,
            },
            {
                name: 'addendMax',
                displayName: 'Addend Max',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: 100,
            },
            {
                name: 'addendIncrement',
                displayName: 'Addend Increment',
                type: 'number',
                min: 0.00000000001,
                max: 2000000000,
                default: 1,
                increment: 0.00000000001,
                helpText: 'For example, if set to 10, numbers will be rounded to 10',
            },
            {
                name: 'numberOfAddends',
                displayName: 'Number of Addends',
                type: 'number',
                min: 2,
                max: 9,
                default: 2,
                increment: 1,
            },
        ],
        subTypes: [
            {
                id: 1,
                name: 'Missing Sum',
            },
            {
                id: 2,
                name: 'Missing Addend (Random)',
            },
        ],
    },
    {
        id: 13,
        key: 'subtract',
        name: 'Subtract',
        params: [
            {
                name: 'displayMode',
                displayName: 'Display Mode',
                type: 'select',
                options: [
                    { id: 1, name: 'Horizontal' },
                    { id: 2, name: 'Vertical' },
                ],
                default: 1,
            },
            {
                name: 'minuendMin',
                displayName: 'Minuend Min',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: -100,
            },
            {
                name: 'minuendMax',
                displayName: 'Minuend Max',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: 100,
            },
            {
                name: 'minuendIncrement',
                displayName: 'Minuend Increment',
                type: 'number',
                min: 0.00000000001,
                max: 2000000000,
                default: 1,
                increment: 0.00000000001,
                helpText: 'For example, if set to 10, numbers will be rounded to 10',
            },
            {
                name: 'subtrahendMin',
                displayName: 'Subtrahend Min',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: -100,
            },
            {
                name: 'subtrahendMax',
                displayName: 'Subtrahend Max',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: 100,
            },
            {
                name: 'subtrahendIncrement',
                displayName: 'Subtrahend Increment',
                type: 'number',
                min: 0.00000000001,
                max: 2000000000,
                default: 1,
                increment: 0.00000000001,
                helpText: 'For example, if set to 10, numbers will be rounded to 10',
            },
            {
                name: 'differenceMax',
                displayName: 'Difference Max',
                type: 'number',
                min: -2000000000,
                max: 2000000000,
                default: 100,
            },
        ],
        subTypes: [
            {
                id: 1,
                name: 'Difference Unknown',
            },
            {
                id: 2,
                name: 'Minuend Unknown',
            },
            {
                id: 3,
                name: 'Subtrahend Unknown',
            },
        ],
    },
];
